<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="userPopup()"
          >新增用户</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="userName" label="用户名"> </el-table-column>
      <el-table-column prop="gender" label="性别">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.gender === 1">男</el-tag>
          <el-tag v-else-if="scope.row.gender === 2" type="warning">女</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="success">有效</el-tag>
          <el-tag v-else type="danger">锁定</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="生日">
        <template slot-scope="scope">
          <template v-if="scope.row.birthday">
            {{ scope.row.birthday | formatDate }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="rolePopup(scope.row.id)"
            >角色配置</el-button
          >
          <el-button type="text" @click="userPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="userDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 用户表单 -->
    <Dialog :title="title" :visible.sync="userFormVisible">
      <el-form
        :model="userForm"
        :rules="userFormRules"
        ref="refUserForm"
        label-width="100px"
        :size="$store.state.formSize"
      >
        <el-form-item label="所属部门：" prop="deptId">
          <el-cascader
            style="width:100%"
            v-model="userForm.deptId"
            :options="deptData"
            :props="{ value: 'id', label: 'deptName', checkStrictly: true }"
            @change="handleChangeDeptId"></el-cascader>
        </el-form-item>
        <el-form-item label="用户名：" prop="userName">
          <el-input
            v-model="userForm.userName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录名：" prop="loginName">
          <el-input
            v-model="userForm.loginName"
            :disabled="loginNameDisabled"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isPassword" label="密码：" prop="password">
          <el-input
            v-model="userForm.password"
            type="password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日：" prop="birthday">
          <el-date-picker
            v-model="userForm.birthday"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            :placeholder="userForm.birthday"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="性别：" prop="gender">
          <el-radio-group v-model="userForm.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="userFormVisible = false"
          >取 消</el-button
        >
      </div>
    </Dialog>
    <Dialog title="角色配置" style="margin-top:15vh!important" :visible.sync="roleFormVisible">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkedRoles">
        <el-checkbox v-for="role in roles" :label="role.id" :key="role.id">{{ role.name }}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceRoleSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="roleCancel">取 消</el-button
        >
      </div>
    </Dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getUserList,
  putUserAdd,
  getUserDetail,
  postUserEdit,
  deleteUserDel,
  delUserList,
  getUserRoleList,
  putUserRoleAdd
} from '@/api/user'
import {
  getRoleList
} from '@/api/role'
import {
  getDeptTree
} from '@/api/dept'

const createFormVals = () => ({
  // 生日
  birthday: '',
  // 部门
  deptId: null,
  // 性别 1:男；2:女
  gender: '1',
  // * 登录名
  loginName: '',
  // * 密码
  password: '',
  // 用户名
  userName: ''
})
const createdFormRules = () => ({
  birthday: [
    { required: true, message: '请选择生日', trigger: 'blur' }
  ],
  deptId: [
    { required: true, message: '请选择所属部门', trigger: 'blur' }
  ],
  gender: [
    { required: true, message: '请选择性别', trigger: 'blur' }
  ],
  loginName: [
    { required: true, message: '请输入登录名', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ],
  userName: [
    { required: true, message: '请输入用户名', trigger: 'blur' }
  ]
})
export default {
  data() {
    return {
      checkAll: false,
      checkedRoles: [],
      roles: [],
      deptData: [],
      isIndeterminate: true,
      currentID: null,
      userId: null,
      isPassword: true,
      isDisabled: false,
      loginNameDisabled: false,
      userFormVisible: false,
      roleFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      tableData: [],
      detailDate: [],
      userForm: createFormVals(),
      loading: true,
      selectionID: [],
      userFormRules: createdFormRules()
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑用户' : '新增用户'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.userSubmit)
    this.debounceRoleSubmit = debounce(300, this.userRoleSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    // 选择部门
    handleChangeDeptId(value) {
      if (value instanceof Array) {
        if (value.length > 1) {
          this.userForm.deptId = value[value.length - 1]
        } else {
          this.userForm.deptId = value[0]
        }
      }
    },
    // 选择角色
    handleCheckAllChange(val) {
      this.checkedRoles = val ? this.roles : []
      this.isIndeterminate = false
    },
    userRoleSubmit(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.roles.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.roles.length
      putUserRoleAdd({
        roleIds: this.checkedRoles,
        userId: this.userId
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.$message.success('配置用户角色成功')
          this.roleFormVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    // 取消选择角色
    roleCancel() {
      this.checkedRoles = []
      this.roleFormVisible = false
      this.checkAll = false
    },
    handleRemoveAll() {
      delUserList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getUserListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getUserListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getUserListData()
    },
    // 删除用户
    userDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUserDel({
            id: id
          }).then(res => {
            if (res.status === 1) {
              this.$message.success('删除用户成功')
              this.getUserListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/编辑用户
    userSubmit() {
      this.$refs.refUserForm.validate(valid => {
        if (!valid) return false
        const changeRole = this.currentID ? postUserEdit : putUserAdd
        changeRole({
          birthday: this.userForm.birthday,
          deptId: this.userForm.deptId,
          gender: this.userForm.gender,
          loginName: this.userForm.loginName,
          userName: this.userForm.userName,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑用户成功') : this.$message.success('新增用户成功')
            this.userFormVisible = false
            this.getUserListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开用户表单
    userPopup(id) {
      const isAdd = !id
      this.userFormVisible = true

      if (isAdd) {
        this.isPassword = true
        this.loginNameDisabled = false
        this.$set(this, 'userForm', createFormVals())
        this.$set(this, 'userFormRules', createdFormRules())
        this.currentID = null
      } else {
        delete this.userFormRules.password
        this.loginNameDisabled = true
        this.isPassword = false
        this.isDisabled = true
        this.currentID = id
        getUserDetail(id).then(res => {
          console.log(res)
          if (res.status === 1) {
            if (res.data.birthday) {
              this.userForm.birthday = moment(res.data.birthday).format('YYYY-MM-DD')
            } else {
              this.userForm.birthday = ''
            }
            this.userForm.deptId = res.data.deptId
            this.userForm.gender = res.data.gender + ''
            this.userForm.loginName = res.data.loginName
            this.userForm.userName = res.data.userName
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getUserListData()
    },
    // 刷新数据表格
    refresh() {
      this.getUserListData()
      this.$message.success('数据刷新成功')
    },
    // 获取用户列表
    getUserListData() {
      this.loading = true
      getUserList({
        page: this.page,
        size: this.size,
        userType: 0,
        userName: this.keywords
      }).then(res => {
        if (res.status === 1) {
          if (res.data) {
            this.total = res.data.total
            this.tableData = res.data.rows
          }
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    // 打开用户角色配置
    rolePopup(id) {
      getUserRoleList(id).then(res => {
        this.roleFormVisible = true
        this.userId = id
        getUserRoleList(id).then(res => {
          this.checkedRoles = res.data.map(_ => _.roleId)
        })
      })
    },
    // 获取角色列表
    getRoleListData() {
      getRoleList({
        page: 1,
        size: 1000
      }).then(res => {
        this.roles = res.data.rows
      })
    },
    // 获取部门列表
    getDeptListData() {
      this.loading = true
      getDeptTree().then(res => {
        console.log(res)
        if (res.status === 1) {
          if (res.data) {
            this.deptData = res.data.slice()
            this.deptData.unshift(
              {
                id: 0,
                parentId: 0,
                deptName: '顶级部门',
                idPath: '',
                isDel: 0,
                orgId: 0,
                parentName: null
              }
            )
            console.log(this.deptData)
          }
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getUserListData()
    this.getRoleListData()
    this.getDeptListData()
  }
}
</script>
